var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"app-main"},[_c('tag-views'),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',[_c('router-view',{key:_vm.key,staticClass:"routerView",on:{"getNoiceNum":_vm.getNoiceNum}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }